module.exports = __webpack_public_path__ + "static/media/driver.3e5b965f.svg";